module.exports =(function() {
  return function(context) {
    return (function() {
      var $c, $e, $o, describeIndicators, i, indicator, len, ref, ref1, type, unit;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      $o.push("<a class='legend__close' href=''>\n  ×");
      $o.push("  " + $c(this.t('legend', 'close')));
      $o.push("</a>\n<a class='closed legend__toggle' href=''>" + ($c(this.t('legend', 'toggle_open'))) + "</a>");
      ref = this.dataType, type = ref[0], unit = ref[1];
      describeIndicators = function(indicators) {
        var i, indicator, len;
        $o.push("<ul class='legend__indicators'>");
        for (i = 0, len = indicators.length; i < len; i++) {
          indicator = indicators[i];
          $o.push("  <p>\n    <strong>" + ($c(indicator.type)) + "</strong>\n    :");
          $o.push("    " + $c(indicator.typeFull + ", " + indicator.unitFull));
          $o.push("  </p>\n  <p>");
          $o.push("    " + $c(this.t('legend', 'maximum_size')));
          $o.push("    " + $c(indicator.maxValue));
          $o.push("  </p>");
        }
        $o.push("</ul>");
        return '';
      };
      $o.push("<section class='legend__section legend__short legend__sources'>\n  <h3 class='legend__heading'>" + ($c(this.t('legend', 'sources'))) + "</h3>\n  <div class='legend__sectionBody'>\n    <ul>\n      <li>");
      $o.push("        " + $c(this.typeName + ':'));
      $o.push("        <a class='legend__source' href='" + ($e($c(this.dataSource.url))) + "' target='_blank'>");
      $o.push("          " + $c(this.dataSource.name));
      $o.push("        </a>\n      </li>");
      ref1 = this.indicators;
      for (i = 0, len = ref1.length; i < len; i++) {
        indicator = ref1[i];
        $o.push("      <li>");
        $o.push("        " + $c(indicator.type + ':'));
        $o.push("        <a class='legend__source' href='" + ($e($c(indicator.sourceURL))) + "' target='_blank'>");
        $o.push("          " + $c(indicator.sourceName));
        $o.push("        </a>\n      </li>");
      }
      $o.push("    </ul>\n  </div>\n</section>\n<section class='legend__explanations legend__long legend__section'>\n  <h3 class='legend__heading'>" + ($c(this.t('legend', 'legend'))) + "</h3>\n  <div class='legend__sectionBody'>\n    <table>\n      <tr class='legend__magnets'>\n        <td class='legend__icon'>\n          <div class='legend__magnet legend__magnetOutgoing' style='background-color: " + ($e($c(this.magnetOutgoingColor))) + "'></div>\n          <div class='legend__magnet legend__magnetIncoming' style='background-color: " + ($e($c(this.magnetIncomingColor))) + "'></div>\n        </td>\n        <td>" + ($c(this.magnetDescription)) + "</td>\n      </tr>\n      <tr class='legend__relations'>\n        <td class='legend__icon'>\n          <span class='legend__relationArrow'></span>\n        </td>\n        <td>" + ($c(this.relationDescription)) + "</td>\n      </tr>");
      if (this.groupedIndicators.absolute) {
        $o.push("      <tr class='legend__absoluteIndicators'>\n        <td class='legend__icon'>\n          <img src='images/legend-indicator-absolute.png' width='20' height='20' alt=''>\n        </td>\n        <td>\n          <p>" + ($c(this.t('legend', 'indicatorIcon', 'absolute'))) + "</p>");
        $o.push("          " + $c(describeIndicators.call(this, this.groupedIndicators.absolute)));
        $o.push("        </td>\n      </tr>");
      }
      if (this.groupedIndicators.proportional) {
        $o.push("      <tr class='legend__proportionalIndicators'>\n        <td class='legend__icon'>\n          <img src='images/legend-indicator-percent.png' width='20' height='20' alt=''>\n        </td>\n        <td>\n          <p>" + ($c(this.t('legend', 'indicatorIcon', 'proportional'))) + "</p>");
        $o.push("          " + $c(describeIndicators.call(this, this.groupedIndicators.proportional)));
        $o.push("        </td>\n      </tr>");
      }
      if (this.indicatorTypes.length > 0) {
        $o.push("      <tr>\n        <td class='legend__icon'>\n          <img src='images/legend-indicator-tendency.png' width='10' height='10' alt=''>\n        </td>\n        <td>" + ($c(this.t('legend', 'tendency'))) + "</td>\n      </tr>");
      }
      $o.push("    </table>\n  </div>\n</section>\n<section class='legend__long legend__section'>\n  <h3 class='legend__heading'>" + ($c(this.t('legend', 'about_heading'))) + "</h3>\n  <div class='legend__sectionBody'>");
      $o.push("    " + $c(this.t('legend', 'about_body')));
      $o.push("  </div>\n</section>");
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "").replace(/[\s\n]*\u0091/mg, '').replace(/\u0092[\s\n]*/mg, '');
    }).call(context);
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./templates/legend.hamlc
// module id = 37
// module chunks = 0